module.exports = __webpack_public_path__ + "static/media/cozy9149.0b740e9f.jpg";